// extracted by mini-css-extract-plugin
export default {"box":"MainLayout_box__jPZPM","gap":"MainLayout_gap__GieEG","content":"MainLayout_content__4s-bC"};